import { render, staticRenderFns } from "./MappingsAdd.vue?vue&type=template&id=52f48359&"
import script from "./MappingsAdd.vue?vue&type=script&lang=js&"
export * from "./MappingsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MappingsAdd.vue"
export default component.exports